import { gql } from 'graphql-tag';
export const GetCustomerInfo = gql`
  query GetCustomerInfo($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id
      firstName
      lastName
      acceptsMarketing
      email
      phone
    }
  }
`;

export const GetProductsByCollection = gql`
  query GetProductsByCollection($collectionHandle: String!) {
    collectionByHandle(handle: $collectionHandle) {
      products(first: 10) {
        edges {
          node {
            id
            title
            description
            handle
            createdAt
            updatedAt
            images(first: 1) {
              edges {
                node {
                  originalSrc
                }
              }
            }
            variants(first: 1) {
              edges {
                node {
                  id
                  priceV2 {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GetProductsById = gql`
  query GetProductById($productId: ID!) {
    product(id: $productId) {
      id
      title
      description
      images(first: 1) {
        edges {
          node {
            transformedSrc(maxWidth: 40, maxHeight: 40)
          }
        }
      }
      variants(first: 1) {
        edges {
          node {
            id
            priceV2 {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;
